module.exports = __webpack_public_path__ + "img/alex_situations.4747f664.svg";